import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";
import { doc, setDoc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

function getGuestId() {
  let guestId = localStorage.getItem("guestId");
  if (!guestId) {
    guestId = "guest_" + Math.random().toString(36).substring(2, 12);
    localStorage.setItem("guestId", guestId);
  }
  return guestId;
}

export default function Rating({ productId }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [avgRating, setAvgRating] = useState(0);
  const [totalRatings, setTotalRatings] = useState(0);
  const guestId = getGuestId();
function getGuestId() {
  let guestId = localStorage.getItem("guestId");
  if (!guestId) {
    guestId = "guest_" + Math.random().toString(36).substring(2, 12);
    localStorage.setItem("guestId", guestId);
  }
  return guestId;
}

  useEffect(() => {
    if (!productId) return;

    const loadRatings = async () => {
      try {
        const productRef = doc(db, "products_ratings", productId);
        const productSnap = await getDoc(productRef);

        if (productSnap.exists()) {
          const data = productSnap.data();
          setAvgRating(data.avgRating || 0);
          setTotalRatings(data.totalRatings || 0);
        } else {
          await setDoc(productRef, { avgRating: 0, totalRatings: 0 });
        }

        // ✅ Load guest rating
        const userRatingRef = doc(db, "products_ratings", productId, "ratings", guestId);
        const userSnap = await getDoc(userRatingRef);
        if (userSnap.exists()) {
          setRating(userSnap.data().value);
        }
      } catch (err) {
        console.error("Error fetching product ratings:", err);
      }
    };

    loadRatings();
  }, [productId, guestId]);

  const handleClick = async (value) => {
    setRating(value);

    try {
      const productRef = doc(db, "products_ratings", productId);
      const userRatingRef = doc(db, "products_ratings", productId, "ratings", guestId);

      // Save guest rating
      await setDoc(userRatingRef, { value });

      // Recalculate average
      const ratingsSnap = await getDocs(collection(db, "products_ratings", productId, "ratings"));
      let total = 0;
      ratingsSnap.forEach((r) => {
        total += r.data().value;
      });
      const newTotalRatings = ratingsSnap.size;
      const newAvgRating = newTotalRatings ? total / newTotalRatings : 0;

      await setDoc(
        productRef,
        { avgRating: newAvgRating, totalRatings: newTotalRatings },
        { merge: true }
      );

      setAvgRating(newAvgRating);
      setTotalRatings(newTotalRatings);
    } catch (err) {
      console.error("Error saving rating:", err);
    }
  };

  return (
    <div>
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <FaStar
            key={star}
            size={16}
            className="cursor"
            color={(hover || rating || Math.round(avgRating)) >= star ? "var(--orange)" : "var(--border-color)"}
            onClick={() => handleClick(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(null)}
          />
        ))}
      </div>
      <div className="text-h3 text-off">
        {avgRating.toFixed(1)} ({totalRatings} ratings)
      </div>
    </div>
  );
}
